export const statePath = 'gandiReduxResourcePrice';
export const baseUrl = '/prices';
export const toQueryParameter = (props = {}) => {
  const filteredProps = {
    ...props
  };
  if ('process' in filteredProps) {
    filteredProps.processes = filteredProps.process;
    delete filteredProps.process;
  }
  return Object.entries(filteredProps).map(([key, value = '']) => {
    if (key === 'sharingId') {
      return `sharing_id=${value}`;
    }
    if (key === 'process') {
      return `processes=${value}`;
    }
    return `${key}=${value}`;
  }).join('&');
};